'use client';

import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import { useAuth } from '../contexts/AuthContext';
import { useRouter } from 'next/navigation';
import { Day, getAvailableDays, getUserTotalScore } from '../lib/api';
import MiniLogo from './MiniLogo';
import styles from './Header.module.css';
import { useTranslation } from 'react-i18next';
const Header: React.FC = () => {
  const { user } = useAuth();
  const router = useRouter();
  const [totalScore, setTotalScore] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  useEffect(() => {
    const fetchTotalScore = async () => {
      try {
        setLoading(true);
        const today = new Date().toISOString().split('T')[0];
        const currentDay = (await getAvailableDays()).data.find(
          (day: Day) => day.date === today
        );
        const response = await getUserTotalScore();
        console.log('response', response);
        setTotalScore(response.data?.totalScore);
      } catch (error) {
        console.error('Error fetching total score:', error);
        setTotalScore(0); // Fallback to 0 if there's an error
      } finally {
        setLoading(false);
      }
    };

    let intervalId: ReturnType<typeof setInterval> | null = null;

    if (user) {
      fetchTotalScore();
      intervalId = setInterval(() => {
        fetchTotalScore();
      }, 60_000);
    }
    const listener = () => {
      if (user) {
        fetchTotalScore();
      }
    };
    window.addEventListener('refresh-score', listener);
    return () => {
      window.removeEventListener('refresh-score', listener);
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [user]);

  const handleAvatarClick = () => {
    router.push('/profile');
  };

  return (
    <header className={styles.header}>
      <div className={styles.logoContainer}>
        <MiniLogo />
      </div>

      <div className={styles.userProfileContainer}>
        <div className={styles.userProfile} onClick={handleAvatarClick}>
          <div className={styles.avatar}>
            {user?.photoURL ? (
              <Image
                src={user.photoURL}
                alt="User Avatar"
                className={styles.avatarImage}
                width={40}
                height={40}
              />
            ) : (
              <div className={styles.avatarPlaceholder}>
                {user?.displayName?.charAt(0) || user?.email?.charAt(0) || 'U'}
              </div>
            )}
          </div>
          <span className={styles.points}>
            {totalScore ?? 0}
            {(totalScore ?? 0) === 1 ? t('PT') : t('PTS')}
          </span>
        </div>
      </div>
    </header>
  );
};

export default Header;
